import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
    Typography, notification
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { validacaoPermissao, VerificaRota } from './../../../../services/VerificaSePodeAcessar';
import { EmitirErro } from '../../../../services/EmitirErro';
import { SairDoSistema } from '../../../../services/LStorage/SairSistema';
import { useGetColumnSearchProps } from './../../../../hooks/FilterTable/string';
import CertidoesService from '../../../../services/http/services/CongelamentoPorCNPJ/CertidoesService';

const { Text } = Typography;

interface IntefDadosTabelaList {
    "id": string,
    "createdAt": string | null,
    "updatedAt": string | null,
    "nome": string | null,
    "taxa": number | null
}

export const useCertidoes = () => {

    const navigate = useNavigate();

    const refContagemDoFiltro = React.useRef<Array<any>>([]);

    const refAbortController = useRef<AbortController>();

    const [dadosTabelaState, setDadosTabelaState] = useState<Array<IntefDadosTabelaList>>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<string | number>>([]);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);

    const [loadingScreen, setLoadingScreen] = useState(false);

    useEffect(() => () => {
        refAbortController.current?.abort();
    }, []);

    //setando dados das cidades no selected
    const reqbuscarDadosTable = useCallback(() => {

        const requestAsync = async () => {
            try {
                setLoadingScreen(true);

                const response = await CertidoesService.getCertidoes(refAbortController.current?.signal);

                setDadosTabelaState(response);

                setLoadingScreen(false);

            } catch (error) {
                setLoadingScreen(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'congelamentoCErtidoes_dkwdfaiweyi')
                }


            }
        }

        requestAsync();

    }, []);

    useEffect(() => {

        refAbortController.current = new AbortController();

        let arrayUrl = window.location.pathname.split("/");
        VerificaRota(arrayUrl, navigate, true, validacaoPermissao(['manage_config_congelamento_cnpj']));

        reqbuscarDadosTable();


    }, []);

    // click na linha da tabela de listagem de usuario
    const onclickTable = useCallback((record: any, row: any): void => {

        if (selectedRowKeys.includes(record.id)) {
            let filter = selectedRowKeys.filter((val) => {
                return val != record.id
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length == 0) {
                setSelectedRowKeys([record.id]);
                setHasSelectedEdit(true);
            } else {
                let teste = selectedRowKeys.concat(record.id);
                setSelectedRowKeys(teste);
                setHasSelectedEdit(false);
            }
        }
    }, [selectedRowKeys]);

    //checkbox da tabela de listagem
    // const onSelectChange = useCallback((selectedRowKeys: any): void => {
    const onSelectChange = useCallback((selectedRowKeys: Array<string | number>, selectedRows: Array<any>): void => {
        if (selectedRowKeys.length > 1) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else if (selectedRowKeys.length === 0) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(true);
        }
    }, [selectedRowKeys]);

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%'
    };

    const columns = [
        {
            title: 'Id Item',
            dataIndex: 'idItem',
            ...useGetColumnSearchProps('idItem'),
            width: '1%',
            // sorter: (a: any, b: any) => a.idItem.localeCompare(b.idItem),
            showSorterTooltip: false,
        },
        {
            title: 'Nome',
            dataIndex: 'nome',
            ...useGetColumnSearchProps('nome'),
            width: '8%',
            sorter: (a: any, b: any) => a.nome.localeCompare(b.nome),
            showSorterTooltip: false,
        },
        {
            title: 'Sigla',
            dataIndex: 'sigla',
            ...useGetColumnSearchProps('sigla'),
            width: '6%',
            sorter: (a: any, b: any) => a.sigla.localeCompare(b.sigla),
            showSorterTooltip: false,
        },
        {
            title: 'Custo',
            dataIndex: 'custo',
            // ...useGetColumnSearchProps('email'),
            width: '6%',
            sorter: (a: any, b: any) => a?.custo - b?.custo,
            showSorterTooltip: false,
            render: (custo: any) => (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {
                        custo &&
                        <Text>
                            {
                                custo
                            }
                        </Text>
                    }
                </div>
            ),
        },
    ];

    const clickBotaoEditar = useCallback((): void => {
        if (selectedRowKeys.length == 1) {

            let objSelecionado: any = {}
            dadosTabelaState.forEach((dados): void => {
                if (dados.id === selectedRowKeys[0]) {
                    objSelecionado = dados
                }
            })

            localStorage.setItem('@DesenvolveSP:configuracoesEditar', JSON.stringify(objSelecionado));

            navigate(`/congelamento-cnpj/certidoes/${selectedRowKeys[0]}`)


        }
    }, [selectedRowKeys, dadosTabelaState]);


    const clickBotaoDeletarDados = useCallback((): void => {

        if (selectedRowKeys.length == 1) {
            let obj: Array<any> = [];
            dadosTabelaState.forEach(({ id }): void => {
                if (id === selectedRowKeys[0]) {
                    obj.push({ id })
                }
            })

            const excluirDadosModal = async () => {
                try {
                    setLoadingScreen(true);

                    await CertidoesService.deleteCertidoes(obj[0]?.id, refAbortController.current?.signal);

                    notification.success({
                        message: 'Sucesso',
                        description:
                            'Seus dados foram excluídos com sucesso!',
                    });

                    setSelectedRowKeys([]);
                    setHasSelectedEdit(false);

                    setLoadingScreen(false);
                    reqbuscarDadosTable();

                } catch (error) {

                    let msgErro: any = (error as Error);

                    setLoadingScreen(false);
                    notification.error({
                        message: 'Erro',
                        description:
                            msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel deletar, entre em contato com suporte!',
                    });
                }
            }

            excluirDadosModal();

        }

    }, [selectedRowKeys, dadosTabelaState]);

    return {
        refContagemDoFiltro,
        columns,
        dadosTabelaState,
        navigate,
        clickBotaoEditar,
        hasSelectedEdit,
        clickBotaoDeletarDados,
        loadingScreen,
        onclickTable,
        rowSelection,
    }
}
